import { render, staticRenderFns } from "./linkus.vue?vue&type=template&id=265554fe&scoped=true"
import script from "./linkus.vue?vue&type=script&lang=js"
export * from "./linkus.vue?vue&type=script&lang=js"
import style0 from "./linkus.vue?vue&type=style&index=0&id=265554fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265554fe",
  null
  
)

export default component.exports